const setting = {
  passwordTitle: "كلمة السر",
  changePasswordBtn: "تغيير كلمة السر",
  changePasswordTips:
    "إذا نسيت كلمة سرك أو تريد تغييرها فيمكنك فعل ذلك من هنا؛ وسنرسل رمز التحقق إلى عنوان بريدك الإلكتروني المسجل، حيث يتم التحقق لتأكيد هويتك، وبعد ذلك يمكنك إعادة تعيين كلمة سر حسابك.",
  feedbackTitle: "الآراء",
  feedbackBtn: "إرسال رأي",
  feedbackTips: "لنقدم لك الأفضل دائمًا، يمكنك وصف مشكلتك هنا وإرسالها لنا لمعرفة رأيك، وسيتواصل معك فريقنا لخدمة العملاء في أقرب وقتٍ ممكن.",
  appearanceTitle: "شاشة المظهر",
  appearanceBtn: "تغيير الشاشة",
  appearanceTips: "لقد اخترنا لك وضعين للمظهر، يمكنك التبديل بين الوضع المظلم والوضع المضيء حسب تفضيلك.",
  changePassWordModalTitle: "تغيير كلمة السر",
  changePassWordSameErrorTips: "كلمة السر الجديدة التي أدخلتها هي نفس كلمة سرك القديمة. أدخل كلمة سر مختلفة.",
  changePasswordCurrentErrorTips: "كلمة سرك غير صحيحة. يرجى المحاولة مرة أخرى.",
  currentPasswordLabel: "كلمة السر الحالية",
  newPasswordLabel: "كلمة سر جديدة",
  retypePasswordLabel: "أعد كتابة كلمة السر",
  changePasswordSuccessTips: "تم تغيير كلمة سرك بنجاح.",
  changePasswordComfirmDiffErrorTips: "يرجى إدخال نفس كلمة السر في كلا الخانتين.",
  forgotPassword: "هل نسيت كلمة السر؟",
  feedbackModalSubtitle: "شكرًا لك على تواصلك معنا وإخبارنا برأيك في منتجنا!",
  feedBackModalProductQuestion: "ما نوع المشكلات التي تريد حبها في منتجنا",
  feedBackModalProductTypeSug: "الاقتراحات",
  feedBackModalProductTypeMem: "الأسئلة المتعلقة بخدمة الأعضاء",
  feedBackModalProductTypeFun: "فحص العمل",
  feedBackModalProductTypeReq: "متطلبات المنتج",
  feedBackModalProductTypeBug: "الآراء في عيوب المنتج",
  feedBackModalProductTypeIss: "مشكلات الأداء",
  feedBackModalProductTypeRL: "أسئلة متعلقة بالتسجيل وتسجيل الدخول",
  feedBackModalProductTypeRef: "خدمة الاسترداد",
  feedBackModalProductTypeOth: "أخرى",
  feedBackModalProductSelectQuestion: "ما نوع المشكلات التي تريد حبها في منتجنا",
  feedBackModalProductContQuestion: "ما هي المشكلة التي تواجهها عند استخدام المنتج؟",
  feedBackModalAddImageBtn: "أضف صورًا",
  feedBackModalTips: "نصائح:",
  feedBackModalTipsCont: "نظرًا لاختلاف وقت خدمة عملائنا العالمية، فإننا سنجيب عليك في غضون 48 ساعة من يوم العمل.",
  feedBackSuccessTips: "تم الإرسال بنجاح",
  feedBackSuccessSubTips: "سنحل مشكلتك في أقرب وقتٍ ممكن",
  feedBackFailedTips: "فشل الإرسال",
  feedBackFailedSubTips: "يرجى التأكد من اتصالك بالانترنت وأرسل مرة أخرى",
  appearanceLightMode: "الوضع المظلم",
  appearanceDarkMode: "الوضع المضيء",
  promotionModalTitle: "ترويج",
  promoItem: "عنصر ترويجي",
  promoCode: "رمز ترويجي",
  discount: "خصم",
  applyBtn: "تطبيق",
  applyPromotionErrorTips: "رمزك الترويجي غير صالح",
};

export default setting;
